module.exports = __webpack_public_path__ + "img/app_management@2x.bcb57d13.png";